var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"loading":_vm.loading,"data":_vm.tableData,"columns":_vm.tableColumns,"size":"small","height":300},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"rateOfProgress",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('b-progress',{staticStyle:{"width":"200px"},attrs:{"variant":row.rateOfProgress <= 20
              ? 'danger'
              : row.rateOfProgress > 20 && row.rateOfProgress <= 40
              ? 'warning'
              : row.rateOfProgress > 40 && row.rateOfProgress <= 60
              ? 'secondary'
              : row.rateOfProgress > 60 && row.rateOfProgress <= 80
              ? 'info'
              : row.rateOfProgress > 80
              ? 'success'
              : '',"height":"0.5rem","value":row.rateOfProgress,"animated":""}}),_c('p',{staticStyle:{"font-size":"12px","margin":"0px"}},[_vm._v(" "+_vm._s(_vm.$l('tips_input_rateOfProgress') || 'Completion')+": "+_vm._s(row.rateOfProgress)+"% ")])],1)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }